import React from 'react';
import { Booker, LazyBookerWrapper } from '../../../LazyBooker';
import BookerSkeleton from './BookerSkeleton';
import type { BookerStepViewProps } from './bookerStepView';
import BookingMarkup from './BookingMarkup';

const LegacyBookerStep = ({
    shouldRenderBooker,
    shouldRenderLoadingSkeleton,
    shouldRenderBookingMarkup,
    onBookerStateChange,
    bookerKey,
    clientId,
    apiUrl,
    language,
    isBookingDryRun,
    commonBookerProps,
}: BookerStepViewProps) => {
    return (
        <>
            {shouldRenderBooker && (
                <LazyBookerWrapper
                    clientId={clientId}
                    apiUrl={apiUrl}
                    language={language}
                >
                    <Booker
                        key={bookerKey}
                        isBookingDryRun={isBookingDryRun}
                        onBookerStateChange={onBookerStateChange}
                        {...commonBookerProps}
                    />
                </LazyBookerWrapper>
            )}
            {shouldRenderLoadingSkeleton && <BookerSkeleton />}
            {shouldRenderBookingMarkup && <BookingMarkup />}
        </>
    );
};

export default LegacyBookerStep;
